import React from "react";
import { Tag } from "antd";
import { ETIQUETAS_RESPUESTA } from "./fasesSoporte";

const TagRespuestaCliente = ({ respuesta, style }) => {
  const etiqueta = ETIQUETAS_RESPUESTA[respuesta];
  if (!etiqueta) return null;

  return (
    <Tag color={etiqueta.color} style={{ borderRadius: 12, padding: "0 10px", marginRight: 0, ...style }}>
      {etiqueta.label}
    </Tag>
  );
};

export default TagRespuestaCliente;
